/** catalogue group: charge items, fee bundles, FX overrides (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const cataloguePermissions = ['catalogue:read', 'catalogue:manage'] as const;

export type CataloguePermission = (typeof cataloguePermissions)[number];
